<template>
	<div class="job-fuzzy-matrix--category">
		<h3>{{ category.label }}</h3>
		<div class="job-fuzzy-matrix--category-rows">
			<Row
				v-for="row in category.rows"
				:key="row.id"
				:row="row"
				:hide-label="category.rows.length === 1"
				:filter-values="filterValues"
				@filterValue="$emit('filterValue', $event)"
			/>
		</div>
	</div>
</template>

<script>
import Row from "./Row";

export default {

	components: {
		Row,
	},

	props: {
		filterValues: {
			type: Array,
			required: true,
		},
		category: {
			type: Object,
			required: true,
		},
	}
}
</script>